import { BaseContainerModel } from '../../base-container.model';
import { Bl_inv_stock_replenishment_template_filter_item_RowClass } from '../../../dbschema/bl_inv_stock_replenishment_template_filter_item.model';

export class StockReplenishmentTemplateFilterItemModel extends BaseContainerModel {
  bl_inv_stock_replenishment_template_filter_item: Bl_inv_stock_replenishment_template_filter_item_RowClass = new Bl_inv_stock_replenishment_template_filter_item_RowClass();
}
